// extracted by mini-css-extract-plugin
export default {"root":"_uc42heTdN","list":"csDQ2yKx9H","item":"cy5A3vClR2","input":"jdGNiAt2yP"};